import { render, staticRenderFns } from "./RemoteFacetFilter.vue?vue&type=template&id=4e25449a"
import script from "./RemoteFacetFilter.vue?vue&type=script&lang=js"
export * from "./RemoteFacetFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports